export const Config = {
  currency: {
    code: 'USD',
    symbol: '$',
  },
};

export const hyperLinks = {
  termsAndConditions:
    'https://s3.eu-central-1.amazonaws.com/public-documents.swise.com/legal/terms-and-conditions-2023-31-03.pdf',
  nda: 'https://s3.eu-central-1.amazonaws.com/public-documents.swise.com/legal/nda-2023-31-03.pdf',
  privacyPolicy:
    'https://s3.eu-central-1.amazonaws.com/public-documents.swise.com/legal/privacy-policy-2023-31-03.pdf',
  qualifiedInvestor:
    'https://s3.eu-central-1.amazonaws.com/public-documents.swise.com/legal/qualified-investor.pdf',
  linkedIn: 'https://www.linkedin.com/company/swiseofficial/',
};
